<template>
<actions-table-layout :children="childrenMenu"/>
</template>

<script>
export default {
  name: 'actions-table-tags',
  props: {
    tag: {
      required: true
    },
    handleRemove: {
      required: true,
      type: Function
    }
  },

  computed: {
    can: function () {
      return Object.keys(this.actions)
    },

    actions: function () {
      return {
        'tags.edit': {
          name: 'tags.edit',
          title: 'Editar Tag',
          color: 'info',
          icon: 'ti-pencil-alt',
          component: 'router-button'
        },
        'tags.remove': {
          name: 'tags.remove',
          title: 'Remover Tag',
          color: 'danger',
          icon: 'ti-trash',
          component: 'action-button-click-stateless',
          props: {
            params: {
              id: this.tag._id
            },
            handleEvent: {
              click: this.handleRemove
            }
          }
        }
      }
    },

    childrenMenu: function () {
      return this.can.filter(item => this.$can(item))
        .map(item => {
          return {
            component: this.actions[item].component,
            data: {
              props: {
                to: {
                  name: this.actions[item].name,
                  params: { id: this.tag._id }
                },
                title: this.actions[item].title,
                classStyle: {
                  btn: true,
                  'btn-block': true,
                  'btn-flat': true,
                  'btn-icon': false,
                  [`btn-${this.actions[item].color}`]: true
                },
                iconClass: this.actions[item].icon,
                ...this.actions[item].props
              }
            }
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Tags/ActionsTableTags.vue